import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useAnalyticsResultsStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[8],
  },

  subTabBar: {
    display: "flex",
    alignItems: "center",
    gap: "0",
    borderBottom: `1px solid ${projectIqTokens.line}`,
    marginBottom: designTokens.spacing[5],
  },

  subTab: {
    background: "transparent",
    border: "none",
    borderBottom: "2.5px solid transparent",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "6px",
    paddingRight: "6px",
    marginRight: "28px",
    marginBottom: "-1px",
    cursor: "pointer",
    fontSize: "14.5px",
    fontWeight: 700,
    color: projectIqTokens.muted,
    transition: designTokens.transition.fast,
    fontFamily: projectIqTokens.fontFamily,
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },

  subTabActive: {
    borderBottom: `2.5px solid ${projectIqTokens.teal}`,
    color: projectIqTokens.ink,
  },

  jumpCard: {
    marginTop: designTokens.spacing[6],
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[4],
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[4],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    textDecoration: "none",
    cursor: "pointer",
    transition: designTokens.transition.base,
    ":hover": {
      boxShadow: projectIqTokens.shadow,
      border: `1px solid ${projectIqTokens.tealLine}`,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },

  jumpCardIcon: {
    width: "40px",
    height: "40px",
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: projectIqTokens.tealSoft,
    color: projectIqTokens.teal,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    flexShrink: 0,
  },

  jumpCardContent: {
    flex: 1,
    minWidth: 0,
  },

  jumpCardTitle: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink,
    margin: "0",
    marginBottom: "2px",
  },

  jumpCardSubtitle: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.muted,
    margin: "0",
    lineHeight: "1.5",
  },

  jumpCardArrow: {
    flexShrink: 0,
    color: projectIqTokens.teal,
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
  },
});
